import {MergeAction, createMergeAction} from './base';

/**
 * Returns the state that enables full page load (e.g. changing language or
 * some other blocking state)
 */
export function enablePageLoad(message='') : MergeAction {
    return createMergeAction(
        'page_load', {ui: {loading: true, loadingMessage: message}}
    );
}

/**
 * Returns the state that disables full page load
 */
export function disablePageLoad() : MergeAction {
    return createMergeAction(
        'page_loaded', {ui: {loading: false, loadingMessage: ''}}
    );
}

/**
 * Returns the state that enables background page load (e.g. loading units,
 * searching, etc.)
 */
export function enableBackgroundLoad(message: string) : MergeAction {
    return createMergeAction(
        'background_load',
        {ui: {background: {loading: true, loadingMessage: message}}}
    );
}

/**
 * Returns the state that disables background page load
 */
export function disableBackgroundLoad() : MergeAction {
    return createMergeAction(
        'background_loaded',
        {ui: {background: {loading: false, loadingMessage: ''}}}
    );
}

/**
 * Returns the state that adds a new error to display to the user
 */
export function addErrorMessage(text: string) : MergeAction {
    return addMessage(text, 'danger');
}

/**
 * Returns the state that adds a new success message to display to the user
 */
export function addSuccessMessage(text: string) : MergeAction {
    return addMessage(text, 'success');
}

/**
 * Returns the state that adds a message with a type to display to the user
 */
export function addMessage(text: string, type: string) : MergeAction {
    return createMergeAction(
        'new_action', {ui: {messages: [
            {text, type}
        ]}}
    );
}

export const DISMISS_MESSAGE = 'DISMISS_MESSAGE';
/**
 * Dismiss error message
 */
export function dismissMessage(index: number) {
    return {
        type: DISMISS_MESSAGE,
        index
    };
}
export const DISMISS_ALL_MESSAGES = 'DISMISS_ALL_MESSAGES';
export function dismissAllMessages() {
    return {
        type: DISMISS_ALL_MESSAGES
    };
}
